<template>
  <div>
    <el-dialog
        title="开发结束资料补充"
        :visible.sync="dialogVisible"
        width="808px"
        v-if="proptions.length>0"
        :before-close="close"
        :close-on-click-modal="false">
      <div>
        <el-form ref="form" class="formSty" :inline="true" label-position="top" :model="form">
          <el-form-item label="客户名称" prop="companyNameMask">
            <el-tooltip placement="top" content="点击解密">

              <div @click="showVal('companyNameMask','companyName')">
                <el-input v-model="form.companyNameMask" disabled
                          style="pointer-events: none;width: 357px;"
                          placeholder="请输入客户名称"
                ></el-input>
              </div>

            </el-tooltip>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="companyCreditCodeMask">
            <el-tooltip placement="top" content="点击解密">
              <div @click="showVal('companyCreditCodeMask','companyCreditCode')">
                <el-input v-model="form.companyCreditCodeMask" :disabled="true"
                          placeholder="请输入统一社会信用代码"
                          style="width: 357px;pointer-events: none;"></el-input>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="所属省份" prop="pr">
            <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
            <el-select v-model="form.pr" disabled @change="prChange" style="width: 357px"
                       placeholder="请选择所属省份">
              <el-option
                  v-for="item in proptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属城市" prop="ci">
            <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
            <el-select v-model="form.ci" disabled @change="ciChange" style="width: 357px"
                       placeholder="请选择所属城市">
              <el-option
                  v-for="item in cioptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区县" prop="cu">
            <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属区县" style="width: 357px"></el-input>-->
            <el-select v-model="form.cu" disabled style="width: 357px"
                       placeholder="请选择所属区县">
              <el-option
                  v-for="item in cuoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户标签" prop="companyLabel">
            <el-select v-model="form.companyLabel" disabled style="width: 357px"
                       placeholder="请选择客户标签">
              <el-option
                  v-for="item in companyLabelOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开发成功" prop="devSuccess">
            <el-select v-model="form.devSuccess" disabled style="width: 357px"
                       placeholder="请选择是否开发成功">
              <el-option
                  v-for="item in devSuccessOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="form.devSuccess=='0'">
            <el-form-item label="开发失败原因" prop="failedType">
<!--              <el-select v-model="form.failedType" disabled style="width: 357px"-->
<!--                         placeholder="请选择开发失败原因">-->
<!--                <el-option-->
<!--                    v-for="item in failedTypeOption"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
              <el-cascader
                  v-model="form.failedType"
                  placeholder="请选择开发失败原因"
                  style="width: 357px"
                  disabled
                  :options="failedTypeOptionT"
                  :props="{ expandTrigger: 'hover' }"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="备注" prop="remarkerr">
              <el-input v-model="form.remarkerr" disabled type="textarea"
                        placeholder="请说明具体失败情况"
                        maxlength="200"
                        :rows="2" style="width: 746px"></el-input>
            </el-form-item>
          </div>
          <div v-if="form.devSuccess=='1'">
            <el-form-item label="客户姓名" prop="contactName">
              <el-input v-model="form.contactName"
                        disabled
                        maxlength="20"
                        placeholder="请输入客户姓名"
                        style="width: 357px;"></el-input>
            </el-form-item>
            <el-form-item label="客户手机号码" prop="contactPhone">
              <el-input v-model="form.contactPhone"
                        disabled
                        placeholder="请输入客户手机号码"
                        style="width: 357px;"></el-input>
            </el-form-item>
            <el-form-item label="开卡状态" prop="cardType">
              <el-select v-model="form.cardType" disabled style="width: 357px" placeholder="请选择">
                <el-option
                    v-for="item in optionsCommonCardStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.cardType == 1" label="联名卡主卡卡号" prop="qqq">
<!--              <el-select v-model="form.qqq" style="width: 357px" disabled placeholder="请选择">-->
<!--                <el-option-->
<!--                    v-for="item in qqqOption"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
              <el-autocomplete
                  v-model="form.qqq"
                  style="width: 357px;"
                  :fetch-suggestions="querySearchAsynclmk"
                  :maxlength='19'
                  disabled
                  placeholder="请输入联名卡卡号"
                  @select="handleSelectlmk"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item
                v-if="form.cardType == 2"
                v-for="(domain, index) in form.domains"
                :key="domain.key"
                :label="index==0?'普通卡主卡卡号及有效卡数量':''"
                :prop="'domains.' + index "
                :rules="{
        required: true, validator: ruleMobile, trigger: 'blur'
      }"
            >
              <div class="cardMesSty">

                <el-input style="width: 357px;margin-right: 30px" placeholder="请输入19位卡号" maxlength=19 disabled
                          v-model="domain.value"></el-input>
                <el-input style="width: 357px" placeholder="请输入有效卡数量" v-model="domain.value2" disabled
                          maxlength=7></el-input>
              </div>
            </el-form-item>
            <el-form-item label="是否有专属优惠" prop="vipDiscount">
              <el-select v-model="form.vipDiscount" style="width: 357px" disabled placeholder="请选择是否有专属优惠">
                <el-option
                    v-for="item in vipDiscountOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.vipDiscount=='1'" label="柴油优惠折算金额(元/升)" prop="num">
              <el-input-number v-model="num" :precision="2" disabled :step="0.01" :min="0" :max="3"></el-input-number>
            </el-form-item>
            <el-form-item v-if="form.vipDiscount=='1'" label="优惠类别" prop="discountType">
              <el-select v-model="form.discountType" disabled style="width: 357px" placeholder="请选择优惠类别">
                <el-option
                    v-for="item in discountTypeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.vipDiscount=='1'" label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" disabled
                        placeholder="请输入具体优惠政策等信息"
                        maxlength="200"
                        :rows="2" style="width: 746px"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
                  <div class="btn_Clo" @click="close">关 闭</div>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import http from "api/freight";
import Util from "utils/util";

export default {
  props: {
    nrData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      companyLabelOption: Util.companyLabelOptionShow,
      devSuccessOption: [
        {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }
      ],
      failedTypeOptionT: Util.failedTypeOptionT,
      num:0,
      form: {
        companyLabel: '',
        devSuccess: '',
        failedType: '',
        companyNameMask: '',
        companyCreditCodeMask: '',
        pr: '',
        ci: '',
        cu: '',
        commonCardStatus: '',
        contactName: '',
        contactPhone: '',
        cardType: '1',
        qqq: '',
        vipDiscount: '',
        discountType: '',
        remark: '',
        remarkerr: '',
        domains: [{
          value: '',
          value2: ''
        }],
      },
      vipDiscountOption: [
        {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }
      ],
      discountTypeOption: Util.discountTypeOption,
      cardStatusOption: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ],
      optionsCommonCardStatus: [
        {
          value: '1',
          label: '联名卡'
        }, {
          value: '2',
          label: '普通卡'
        }
      ],
      dialogVisible: true,
      proptions: [],
      cioptions: [],
      cuoptions: [],
      qqqOption: [],
      mobileReg: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
      currRow: {},
    }
  },
  mounted() {
    this.getPrev()
    this.getInfo()
  },
  methods: {
    querySearchAsynclmk(queryString, cb) {
      let results = this.qqqOption.filter(item => item.label.indexOf(queryString) > -1)
      cb(results)
    },
    handleSelectlmk(item) {
      this.form.qqq = item.value
    },
    getPrev() {
      http.getCountyAreaList({
        code: '0',
        areaType: 'PROVINCE'
      }).then((e) => {
        if (e.data.length > 0) {
          this.proptions = e.data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
        }
      })
    },
    getInfo() {
      let params = {
        id: this.nrData.id,
      }
      this.qqqOption = []
      http
          .cardInfoAll(params)
          .then((e) => {
            if (e.code == 200) {
              if (e.data.cbCardInfo.cardNos) {
                e.data.cbCardInfo.cardNos.forEach(item => {
                  this.qqqOption.push({
                    value: item,
                    label: item
                  })
                })
              }
              const baseMees = e.data.companyInfo
              this.form.companyNameMask = baseMees.companyNameMask
              this.form.companyCreditCodeMask = baseMees.companyCreditCodeMask
              this.form.pr = baseMees.provcode
              this.form.ci = baseMees.citycode
              this.form.cu = baseMees.countycode
              this.currRow = baseMees
              this.prChange()
              // const cbCardInfo = e.data.cbCardInfo
              // this.form.cardStatus = cbCardInfo.cardStatus.toString()
              // this.form.cardCount = cbCardInfo.cardCount
              // this.form.cardNos = cbCardInfo.cardNos
              // const cbCardDiscount = e.data.cbCardDiscount
              // this.form.cardNo = cbCardDiscount.cardNo
              // this.form.vipDiscount = cbCardDiscount.vipDiscount.toString()
              // this.form.discountType = cbCardDiscount.discountType.toString()
              // this.form.remark = cbCardDiscount.remark
              // const commonCardInfo = e.data.commonCardInfo
              // this.form.commonCardStatus = commonCardInfo.cardStatus.toString()
              // if (commonCardInfo.cardNos) {
              //   this.form.domains = []
              //   commonCardInfo.cardNos.forEach(item => {
              //     let val = item.split('_')
              //     this.form.domains.push({
              //       value: val[0],
              //       value2: val[1]
              //     })
              //   })
              // }
              // const commonCardDiscount = e.data.commonCardDiscount
              // if (commonCardDiscount.cardNo) {
              //   this.form.domains2 = []
              //   let val = commonCardDiscount.cardNo.split('_')
              //   this.form.domains2.push({
              //     value: val[0],
              //     value2: val[1]
              //   })
              // }
              // this.form.vipDiscount2 = commonCardDiscount.vipDiscount.toString()
              // this.form.discountType2 = commonCardDiscount.discountType.toString()
              // this.form.remark2 = commonCardDiscount.remark
            }
          })
      http
          .completeInfoTar(params)
          .then((e) => {
            if (e.code == 200) {
              let nrData = e.data
              this.form.devSuccess = nrData.devSuccess + ''
              this.form.contactName = nrData.contactName
              this.form.contactPhone = nrData.contactPhone
              this.form.cardType = nrData.cardType+''
              if (nrData.cardType=='1'){
                if (nrData.cardNo) {
                  this.form.qqq = nrData.cardNo
                }
              }else{
                if (nrData.cardNo) {
                  this.form.domains = []
                  let val = nrData.cardNo.split('_')
                  this.form.domains.push({
                    value: val[0],
                    value2: val[1]
                  })
                }
              }
              this.form.vipDiscount = nrData.vipDiscount+''
              this.form.discountType = nrData.discountType+''
              this.form.remark = nrData.remark

              this.form.companyLabel = nrData.companyLabel?nrData.companyLabel:'-'
              this.num = nrData.dieselDiscountPrice

              this.form.failedType=nrData.failedType+''
              this.form.remarkerr=nrData.failedRemark

            }
          })
    },
    async ciChange() {
      this.cuoptions = []
      this.form.cu = ''
      const {data} = await http.getCountyAreaList({
        code: this.form.ci,
        areaType: 'COUNTY'
      })
      if (data.length > 0) {
        this.cuoptions = data
            .map(item => ({
              value: item.code,
              label: item.name,
            }));
      } else {
        this.cuoptions = this.cioptions.filter(item => item.value == this.form.ci)
      }
      this.form.cu = this.currRow.countycode
    },
    ruleMobile(rule, value, callback) {
      if (!value.value || !value.value2) {
        callback(new Error('请输入主卡卡号及有效卡数量!'))
      } else {
        if (!/^\d+$/.test(value.value) || !/^\d+$/.test(value.value2)) {
          callback(new Error('请输入数字!'))
        } else {
          if (value.value.length == 19) {
            callback();
          } else {
            callback(new Error('请输入主卡卡号19位数字!'))
          }
        }
      }
    },
    prChange() {
      this.cuoptions = []
      this.cioptions = []
      this.form.ci = ''
      this.form.cu = ''
      http.getCountyAreaList({
        code: this.form.pr,
        areaType: 'CITY'
      }).then((e) => {
        if (e.data.length > 0) {
          this.cioptions = e.data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
          this.form.ci = this.currRow.citycode
          this.ciChange()
        }
      })
    },
    showVal(oldVal, newVal) {
      this.form[oldVal] = this.currRow[newVal]
    },
    close() {
      this.$emit('changeDetail')
    },
    rulePhone(rule, value, callback) {
      let reg = this.mobileReg
      if (!value) {
        callback(new Error('请输入客户手机号码'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的客户手机号码'));
        // this.codeStatus = true
      } else {
        if (!this.time) {
          // this.codeStatus = false
        }
        callback();
      }
    },
    companyCred(rule, value, callback) {
      if (value) {
        if (!this.isShowInput) {
          if (!/^[A-Za-z0-9]+$/.test(value)) {
            callback(new Error('请输入正确的统一社会信用代码！'))
          } else {
            if (value.length != 18) {
              callback(new Error('请输入正确的统一社会信用代码！'))
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      } else {
        callback(new Error('请输入正确的统一社会信用代码！'))
      }

    },
  }
}
</script>
<style lang="stylus" scoped>
.cardMesSty {
  display: flex;
  align-items: center;
}

.changeClass {
  display: flex;

  div {
    width: 74px;
    line-height: 32px;
    border-radius: 2px 0px 0px 2px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    text-align: center;
    font-style: normal;
  }

  .active {
    color: #336EB0;
    border: 1px solid #336EB0;
  }
}

.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  text-align: left;
  font-style: normal;
  align-items: center;
  display: flex;
  margin-top: 24px;
  padding-bottom: 16px;

  i {
    width: 2px;
    height: 14px;
    display: block;
    background: #336EB0;
    margin-right: 10px;
  }
}

.formSty {
  /deep/ .el-form-item__label {
    line-height: 20px;
  }

  /deep/ .el-input--medium .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

/deep/ .el-dialog__body {
  padding: 20px 0 20px 30px;
  border-bottom: 2px solid #EEEEEE;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.btn_Sub {
  width: 64px;
  line-height: 33px;
  background: #336EB0;
  border-radius: 2px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
  padding: 0;
}

.btn_Clo {
  width: 64px;
  line-height: 33px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-style: normal;
  padding: 0;
  margin-left: 8px;
}
</style>
